<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: "App",
  methods: {
    calc() {
      const { clientWidth, style } = document.documentElement;
      style.fontSize = clientWidth / 20 + "px";
    },
  },
  created() {
    this.calc();
    window.addEventListener("resize", this.calc);
  },
};
</script>
<style>
body {
  font-size: 16px;
  background-color: #f8f8f8;
  -webkit-font-smoothing: antialiased;
}

#app {
  overflow: scroll;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0;
}

.flex {
  display: flex !important;
}

.full {
  width: 100% !important;
}

.jc-sb {
  justify-content: space-between;
}

.ai-c {
  align-items: center;
}

.ai-fe {
  align-items: flex-end;
}

.ta-c {
  text-align: center !important;
}

.m-auto {
  margin: 0 auto;
}

.mr-10 {
  margin-right: 10px !important;
}

.mb-10 {
  margin-bottom: 10px !important;
}

.float-right {
  float: right !important;
}

.float-left {
  float: left !important;
}

.green {
  color: #07c160;
}

.red {
  color: #e7212f;
}

.blue {
  color: #3867fa;
}
@keyframes rotating {
  0% {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(1turn);
  }
}
</style>
